import appelerApiService from './appeler-api.service';

let socket;
let connecte;
let deconnexionDemandee = false;
let appelWebsocketEnCours = false;
let premierLancementFait;
let traitements = {};
let idReconnexion = null;
let intervalleTentatives = 15000;

const traiterMessagesWebsocket = (message) => {
    if (!message.startsWith('{')) {
        console.error('Format inconnu', message);
        return;
    }
    try {
        const contenu = JSON.parse(message);
        traitements[contenu.fonction](contenu.donnees);
    } catch (erreur) {
        console.error(erreur);
    }
};

const reconnecter = () => {
    connecte = false;
    clearInterval(idReconnexion);
    connecterWebSocket();
    changerIntervalleTentatives(15000);
};

const changerIntervalleTentatives = (nouvelleValeur) => {
    intervalleTentatives = nouvelleValeur;
    idReconnexion = setInterval(() => {
        if (connecte) {
            clearInterval(idReconnexion);
            return;
        }
        connecterWebSocket();
    }, nouvelleValeur);
};

const connecterWebSocket = (premierLancement) => {
    if (appelWebsocketEnCours || connecte || (premierLancement && premierLancementFait)) {
        return;
    }
    appelWebsocketEnCours = true;
    premierLancementFait = true;
    appelerApiService.get('demander-jeton-websocket')
    .then(resultat => resultat.jeton)
    .then(jeton => {
        const url = (window.location.hostname === 'localhost') ? 'localhost:3001' : window.location.host;
        const protocole = (window.location.protocol === 'https:') ? 'wss:' : 'ws:';
        const socket = new WebSocket(`${protocole}//${url}?jeton=${jeton}`);
        return socket;
    })
    .then(socket => {
        appelWebsocketEnCours = false;
        socket.addEventListener('message', (event => traiterMessagesWebsocket(event.data)));
        socket.addEventListener('close', (() =>  {
            if (deconnexionDemandee) {
                return;
            }
            reconnecter();
        }));
        socket.addEventListener('open', (() =>  {
            connecte = true;
        }));
    })
    .catch(err => {
        appelWebsocketEnCours = false;
        changerIntervalleTentatives(intervalleTentatives * 1.5);
        console.error(err);
    });
};

export default {
    connecterWebSocket,

    deconnecterWebSocket: () => {
        connecte = false;
        deconnexionDemandee = true;
        if (socket) {
            socket.close();
        }
        if (idReconnexion) {
            clearInterval(idReconnexion);
        }
    },

    /*
        Message :
        {
            "fonction": "",
            "donnees": {}
        }
    */

    enregistrerFonction: (nomFonction, traitement) => {
        traitements[nomFonction] = traitement;
    }
};